const messages = {
  nomeUni: " Istituto Patristico Augustinianum",
  email: "E-mail",
  password: "Password",
  testoLogo: "testoLogo",
  semestre: "Semester",
  NonDefinito: "-- Undefined --",
  carattereNonValido: "You entered an invalid character!",
  presentazione:
    "Welcome to the Enrollment page for the Academic Year {annoaccaS}/{annoaccaF}",
  cardCompleta: "Completed",
  cardDaCompletare: "To be completed",
  conferma: "Confirm",
  chiudi: "Close",
  avanti: "Next",
  indietro: "Back",
  campiObbligatori: "* indicates the mandatory fields",
  campoObbligatorio: "Mandatory field",
  checkCampiObbligatori: "Fill in all mandatory fields!",
  tastoStep: { compila: "Fill", modifica: "Edit" },
  si: "YES",
  no: "NO",
  errore: "Warning! An error occurred.",
  chiuse:
    "Warning! The applications are closed, check the academic calendar on the University's website.",
  salva: "Save",
  stepCompilati_1: "You have completed",
  stepCompilati_2: "out of {step} forms",
  stepCompletati:
    "You have completed all the required fields. Now click on the registration button to send your application",
  noData: "No records found!",
  login: {
    confermaReset:
      "If the entered information is correct, within a few minutes you will receive the new password to your e-mail address!",
    nuovoStudente: {
      titolo: "Are you a new student?",
      testo: `If you want to start the enrollment procedure, click on “REGISTER” and enter your email. You’ll receive the password to be used to access the compilation form.`,
    },

    vecchioStudente: {
      titolo: "Already a student?",
      testo: `If you already have a student matriculation number, click here:`,
    },
    titolo: "Access your registration form",
    accedi: "Access",
    forgotPassword: "Forgot password?",
    noRegistrato: "Not registered yet?",
    registrati: "Register",
    recuperoPassword: "Password recovery",
    recuperoPasswordLabel: "Enter the email used for the registration *",
    registrazioneUtente:
      "Enter your email and we will send you the credentials to access the enrollment procedure",
    registrazioneUtenteConferma:
      "We’ve just sent you an email, check your inbox!",
    registrazioneUtenteEmailEsistente: "Email in use",
    recupera: "Recover account",
    emailNonValida: "Invalid email!",
    loginErrato: "Invalid email or password!",
    domandaInLavorazione:
      "Your enrollment request is being processed. It is not possible to make changes.",
    statoPresentata:
      "An enrollment request has already been registered. <br> If you send a new request, the previous one will be canceled.",
  },

  logOut: {
    domanda: "Do you want to exit?",
    nota: "<b>Remember to save or the provided information will be lost.</b>",
  },
  istruzioni: {
    tasto: "Instructions",
    esci: "Exit",
    avanti: "Next",
    indietro: "Back",
    fine: "End",
    step1: "Start from here!",
    step2: "if you want you can temporarily save your data and continue later!",
    step3:
      "You can send your enrollment application after having completed all the required fields",
  },

  introduzione: {
    titolo: "Norms and conditions",
    testo_iniziale:
      "To continue it is necessary to agree with the processing of data in accordance with the regulations in force, including those concerning the protection of personal data (European Regulations 2016/679)",
    testo_consenso:
      "<br>consent to the processing in relation to the purposes specified in point 2) letters a) b) c) d) of the Information pursuant to art. 13 of the European Regulation 2016/679.<br> The undersigned consents to the processing of personal data, in relation to the following purposes (tick the purposes for which the consent is made explicit):",
    tasto_informativa:
      "Information pursuant to art. 13 of the European Regulation 2016/679",
    consenso1:
      "fulfillment of the contractual obligations assumed by the Gregorian University towards me (mandatory);",
    consenso2:
      "fulfillment of legal, tax and statutory obligations related to or deriving from my enrollment at the Gregorian University (mandatory);",
    consenso3:
      "publication within the official documents of the University such as: student yearbook, Ordo Anni Academici, Liber Annualis, inauguration of the academic year;",
    consenso4:
      "advertising, in relation to the organization of charitable initiatives, conferences, seminars, courses of study managed, sponsored or promoted by the Gregorian University.",
    consenso_norme_condotta:
      "Rules of conduct in the event of sexual or moral harassment.",
    conferma: "Got it",
  },

  anagrafica: {
    titolo: "Personal data",
    cognome: "Surname/Last Name",
    nome: "Name",
    datanascita: "Date of birth (dd/mm/yyyy)",
    nazionenascita: "Country of birth",
    comunenascita: "City of birth",
    statocivile: "Status",
    linguamadre: "Native language",
    sesso: "Sex",
    religione: "Religion",
    cittadinanza: "Citizenship",
    "2cittadinanza": "2nd citizenship",
    ordinereligioso: "Religious order",
    codicefiscale: "Tax code/Codice fiscale",
    fototessera: "Upload photograph",
    fototesseraInfo: "Upload a jpg format picture",
    CFNoValido: "Invalid tax code/codice fiscale",
    copiaResidenza: "Copy residence information",
    diocesi: "Diocese",
    collegio: "College",
  },

  indirizzi: {
    titolo: "Enter your contact details",
    titoloResidenza: "Residency in your home country",
    titoloRecapito: "Domicile",
    cap: "CAP/Zip code",
    nazione: "Nation",
    comune: "City",
    telefono: "Phone number",
    indirizzo: "Address",
    presso: "At",
    cellulare: "Mobile phone number",
    formatoCap: "Invalid format!",
  },

  studiprevi: {
    titolo: "Previous studies and language skills",
    studiPreuni: "Pre-university studies",
    studiFilosofia: "Philosophy studies",
    studiTeologia: "Theology studies",
    studiAltro: "Other studies (literature, law, history, psychology, etc.)",
    titoloStudio: "Educational qualification",
    istituto: "Institution",
    anno: "Year of Graduation",
    votazione: "Grade",
    lingue: {
      titolo: "Language skills",
      antiche: "Ancient languages",
      latina: "Latin",
      greca: "Greek",
      ebraica: "Hebrew",
      moderne: "Modern languages",
      francese: "French",
      inglese: "English",
      italiana: "Italian",
      spagnola: "Spanish",
      tedesca: "German",
      livello: {
        discreto: "Fair",
        buono: "Good",
        eccellente: "Excellent",
      },
      reset: "Delete",
    },
  },

  iscrizione: {
    titolo: "Choose the cycle of studies",
    facolta: "Academic Unit",
    ciclo: "Cycle of studies",
    specializzazione: "Specialization",
    annodicorso: "Course year",
    tipoiscrizione: "Type of enrollment",
    categoria: "Category",
    domandaOspite: "Do you want to enroll as a guest student?",
    cambioIscrizione:
      "Warning! You changed your enrollment information. Check and confirm the uploaded documents and chosen courses.",
    infoCategoria:
      "A guest is a student who attends a maximum of 3 courses per semester.",
    infoAnnoCorso: "1 - First year <br> 2 - Second year <br> 3 - Third year",
    infoIscrizione: "",
    scegliciclo: "choose cycle",
    sceglianno: "choose cycle",
    infoCategoriaORDSTR:
      "Extraordinary is a student that does not have the requirements to obtain the final grade for a cycle of studies",
    notaFacolta: "Notice from the Faculty",
    confermaNota: "I understand",
  },

  documenti: {
    titolo: "Upload the documents required for the enrollment",
    caricaFile: "Upload file ({formato})",
    fileCaricato: "File uploaded correctly",
    fileObbligatorio: "Mandatory document!",
    fileTooBig: "The file is too heavy! (max 2MB)",
    fileErrato: "Invalid file extension!",
    anteprima: "Preview",
    cancella: "Delete",
    foto: "Your picture",
    istruzioniFoto:
      "Move the frame so as to correctly show your face (you can zoom the picture!). Check your badge preview in the box on the right. Press ‘CONFIRM’.",
    anteprimaBadge: "Badge preview",
  },

  corsi: {
    seminariLettureChiuse:
      "Attention, the enrollments are closed. It is no longer possible to choose Seminars and Guided Readings.",
    sem1: " (annual or 1° semester)",
    sem2: " (2° semester)",
    nonTrovato1Sem: "Course does not exist or belongs to the 2° semester",
    nonTrovato2Sem: "Course does not exist or belongs to the 1° semester",
    titolo: "Courses preferences",
    corsi: "Courses",
    seminari: "Seminars",
    letture: "Guided readings",
    preparazione: "List loading… (wait)",
    ricerca: "Search (course, teacher, heading)",
    di: "of",
    nocorsi: "No {tipocorso} for the selected cycle of studies.",
    tuttiCorsi: "Show courses from all Faculties/Academic Units",
    selezionati: "Selected",
    selezionatiOrdinati:
      "To change the order of preference drag the chosen option or delete the wrong one",
    obbligatori:
      "this course will be automatically included in your study plan",
    aggiungi: "Add",
    aggiunto: "Course &nbsp;<b>{corso}</b>&nbsp; added!",
    giaScelto:
      "Warning! The course &nbsp;<b>{corso}</b>&nbsp; is already added!",
    cancellazione: "Do you want to delete the course {corso} ?",
    attenzione: "Warning!",
    maxCorsi:
      "You have reached the maximum number of courses that can be selected for the chosen cycle of studies.",
    maxSeminari:
      "You have reached the maximum number of seminars that can be selected for the chosen cycle of studies.",
    maxLetture:
      "You have reached the maximum number of guided readings that can be selected for the chosen cycle of studies.",
    minCorsi: "You have to choose n°{corsi} more courses",
    minCorsiOK: "You have reached the minimum required number of courses!",
    minSeminari: "You have to choose n°{corsi} more seminars",
    minSeminariOK: "You have reached the minimum required number of seminars!",
    minLetture: "You have to choose n°{corsi} more guided readings",
    minLettureOK:
      "You have reached the minimum required number of guided readings!",
    nessunaSelezione: "No course selected yet!",
    noScelta: "Warning! You have to choose at least {minCorsi} courses!",
    troppiCorsi: "Warning! You can choose a maximum of {maxCorsi} courses!",
    noSceltaSeminari:
      "Warning! You have to choose at least {minCorsi} seminars!",
    troppiSeminari: "Warning! You can choose a maximum of {maxCorsi} seminars!",
    noSceltaLetture:
      "Warning! You have to choose at least {minCorsi} guided readings!",
    troppiLetture:
      "Warning! You can choose a maximum of {maxCorsi} guided readings!",
    corsiOspitiFuoriFacolta:
      "Warning! You have to choose at least one course belongs the Faculty of: {facolta}",
    avvisoDogmatica:
      "If you want to take one seminar this semester, indicate 3 choices; if you want to take two, add 3 more choices (total 6 choices in order of preference).",
  },

  invioRichiesta: {
    btnInvio: "send your application",
    domanda: "Do you want to send your application?",
    nota:
      "The Secretariat will take charge of your request as soon as possible",
    btnConferma: "YES",
    btnAnnulla: "Cancel",
    fine: {
      titolo: "You have finished!",
      testo:
        "Your request has been sent. In a few minutes you will receive an e-mail with the summary of your application.",
    },
  },
  salvaDati: {
    info:
      "Temporarily save the current information. You can complete your application later.",
    domanda: "Do you want to save the current information?",
    nota: "You can complete your application later!",
    btnConferma: "YES",
    btnAnnulla: "Cancel",
    fine: {
      titolo: "The data have been saved!",
      testo: "",
    },
  },
};

export default messages;
